var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CreativeAttachTargets } from '../Constants';
import { CreativeSchedule } from '@/models/CampaignOperation/CompoundCampaign';
import { genRequestParamsMenuSetting, } from '.';
export default (function (form, uploadFile) {
    var _a;
    var advertiserId = form.advertiserId, insertionOrderId = form.insertionOrderId, campaign = form.campaign;
    var isCampaignCreative = campaign.creativeAttachTarget === CreativeAttachTargets.CAMPAIGN;
    var content = {
        advertiserId: advertiserId,
        insertionOrderId: insertionOrderId,
        campaign: convertFromCampaign(campaign, isCampaignCreative),
        menuSetting: genRequestParamsMenuSetting(campaign.menuSetting, isCampaignCreative, (_a = campaign.menu) === null || _a === void 0 ? void 0 : _a.menuType),
    };
    if (uploadFile) {
        var formData = new FormData();
        formData.append('uploadFile', uploadFile);
        var blob = new Blob([JSON.stringify(content)], {
            type: 'application/json',
        });
        formData.append('compoundCampaign', blob);
        return formData;
    }
    else {
        return content;
    }
});
var convertFromCampaign = function (campaign, isCampaignCreative) {
    var id = campaign.id, name = campaign.name, menuId = campaign.menuId, code = campaign.code, creativeType = campaign.creativeType, creativeAttachTarget = campaign.creativeAttachTarget, creatives = campaign.creatives, enablePacingPerBudget = campaign.enablePacingPerBudget, pacingType = campaign.pacingType, dailyLimitBudget = campaign.dailyLimitBudget, evenPacePercentage = campaign.evenPacePercentage, campaignBudgets = campaign.campaignBudgets, temporaryCampaignBudgets = campaign.temporaryCampaignBudgets, menu = campaign.menu, useAdvancedSetting = campaign.useAdvancedSetting, goalType = campaign.goalType, goalValue = campaign.goalValue, enableOptimization = campaign.enableOptimization, useCreativeSchedule = campaign.useCreativeSchedule, advancedSetting = campaign.advancedSetting;
    var withOutCreativeParams = {
        id: id,
        name: name,
        ownerProfileMenuId: menuId,
        menuType: menu === null || menu === void 0 ? void 0 : menu.menuType,
        code: code,
        creativeType: creativeType,
        creativeAttachTarget: creativeAttachTarget,
        enablePacingPerBudget: enablePacingPerBudget,
        pacingType: pacingType,
        dailyLimitBudget: dailyLimitBudget,
        evenPacePercentage: evenPacePercentage,
        campaignBudgets: campaignBudgets.map(convertFromCampaignBudget),
        temporaryCampaignBudgets: temporaryCampaignBudgets.map(convertFromTemporaryCampaignBudget),
        useAdvancedSetting: useAdvancedSetting,
        goalType: goalType,
        goalValue: goalValue,
        enableOptimization: enableOptimization,
        useCreativeSchedule: useCreativeSchedule,
        advancedSetting: convertAdvancedSetting(advancedSetting),
    };
    return isCampaignCreative
        ? __assign(__assign({}, withOutCreativeParams), { creatives: creatives }) : withOutCreativeParams;
};
var convertAdvancedSetting = function (advancedSetting) {
    var deliveryDevices = advancedSetting.deliveryDevices, deliveryInventories = advancedSetting.deliveryInventories, inventoryListOptionalIds = advancedSetting.inventoryListOptionalIds, onlyJapaneseDevice = advancedSetting.onlyJapaneseDevice, weeklyDeliverySchedule = advancedSetting.weeklyDeliverySchedule, ipAreaSetting = advancedSetting.ipAreaSetting, demographicSetting = advancedSetting.demographicSetting;
    return {
        deliveryDevices: deliveryDevices,
        deliveryInventories: deliveryInventories,
        inventoryListOptionalIds: inventoryListOptionalIds,
        onlyJapaneseDevice: onlyJapaneseDevice,
        weeklyDeliverySchedule: weeklyDeliverySchedule.map(function (schedule) { return convertWeeklyDeliverySchedule(schedule); }),
        ipAreaSetting: convertFromIpAreaSetting(ipAreaSetting),
        demographicSetting: convertFromDemographicSetting(demographicSetting),
    };
};
var convertFromDemographicSetting = function (demographicSetting) {
    var id = demographicSetting.id, sex = demographicSetting.sex, marriage = demographicSetting.marriage, age = demographicSetting.age, prefecture = demographicSetting.prefecture;
    return {
        id: id,
        sex: sex,
        marriage: marriage,
        age: age,
        prefecture: prefecture,
    };
};
var convertFromCampaignBudget = function (campaignBudget) {
    var id = campaignBudget.id, budget = campaignBudget.budget, dailyLimitBudget = campaignBudget.dailyLimitBudget, evenPacePercentage = campaignBudget.evenPacePercentage, pacingType = campaignBudget.pacingType, startTime = campaignBudget.startTime, endTime = campaignBudget.endTime, insertionOrderBudgetId = campaignBudget.insertionOrderBudgetId, creativeSchedules = campaignBudget.creativeSchedules, deleted = campaignBudget.deleted;
    return {
        id: id,
        budget: budget,
        dailyLimitBudget: dailyLimitBudget,
        evenPacePercentage: evenPacePercentage,
        pacingType: pacingType,
        startTime: startTime,
        endTime: endTime,
        insertionOrderBudgetId: insertionOrderBudgetId,
        creativeSchedules: creativeSchedules.map(CreativeSchedule.assign),
        deleted: deleted,
    };
};
var convertFromTemporaryCampaignBudget = function (campaignBudget) {
    var id = campaignBudget.id, budget = campaignBudget.budget, dailyLimitBudget = campaignBudget.dailyLimitBudget, evenPacePercentage = campaignBudget.evenPacePercentage, pacingType = campaignBudget.pacingType, startTime = campaignBudget.startTime, endTime = campaignBudget.endTime, insertionOrderBudgetRequestId = campaignBudget.insertionOrderBudgetRequestId, creativeSchedules = campaignBudget.creativeSchedules, deleted = campaignBudget.deleted;
    return {
        id: id,
        budget: budget,
        dailyLimitBudget: dailyLimitBudget,
        evenPacePercentage: evenPacePercentage,
        pacingType: pacingType,
        startTime: startTime,
        endTime: endTime,
        insertionOrderBudgetRequestId: insertionOrderBudgetRequestId,
        creativeSchedules: creativeSchedules.map(CreativeSchedule.assign),
        deleted: deleted,
    };
};
var convertFromIpAreaSetting = function (ipAreaSetting) {
    var ipAreaType = ipAreaSetting.ipAreaType, ipAreaIds = ipAreaSetting.ipAreaIds;
    return {
        ipAreaType: ipAreaType,
        ipAreaIds: ipAreaIds,
    };
};
var convertWeeklyDeliverySchedule = function (weeklyDeliverySchedule) {
    var day = weeklyDeliverySchedule.day, startHour = weeklyDeliverySchedule.startHour, endHour = weeklyDeliverySchedule.endHour;
    return {
        day: day,
        startHour: startHour,
        endHour: endHour,
    };
};
